
// reactstrap components
import {
  Badge,
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Media,
  Pagination,
  PaginationItem,
  PaginationLink,
  Progress,
  Table,
  Container,
  Row,
  UncontrolledTooltip,
  Button
} from "reactstrap";
// core components
import Header from "components/Headers/Header.js";
import { useEffect, useState } from "react";
import { useAccount } from "flow/flowContext";
import { getAccountData } from "flow/scripts/account";
import KeysManagerHeader from "components/Headers/KeysManagerHeader";
import CapabilitiesManagerHeader from "components/Headers/CapabilitiesManagerHeader";
import { getCapabilities } from "flow/scripts/account";
import SendCapabilityModal from "components/Modals/SendCapabilityModal";
import * as APIURLS from "../../config/apiUrls";
import axios from "axios";
import { unsendCapability } from "flow/transactions/account";
import { JsonView, darkStyles, defaultStyles } from 'react-json-view-lite';

const CapabilitiesManager = () => {
  const [sendCapabilityModal, setSendCapabilityModal] = useState(false);
  const sendCapabilityModalToggle = () => setSendCapabilityModal(!sendCapabilityModal);

  const { address, isConnected, disconnect, connect } = useAccount();
  const [accountData, setAccountData] = useState(null);
  const [capabilities, setCapabilities] = useState(null);

  const [sendCapabilityData, setSendCapabilityData] = useState(null);

  const [inboxCapabilities, setInboxCapabilities] = useState(null);
  const [outboxCapabilities, setOutboxCapabilities] = useState(null);


  const fetchAccountData = async () =>{
    const accountData = await getAccountData(address)
    setAccountData(accountData)
  }

  const fetchCapabilities = async () =>{
    const capabilitiesData = await getCapabilities(address)
    console.log(capabilitiesData)
    setCapabilities(capabilitiesData)
  }

  const fetchInboxCapabilities = async () =>{
    const inboxValues = await axios.post(`${APIURLS.INBOX_CAPABILITY_URL}`, {userAddress: address});
    console.log("Inbox")
    console.log(inboxValues.data)
    setInboxCapabilities(inboxValues.data.data)
  }

  const fetchOutboxCapabilities = async () =>{
    const outboxValues = await axios.post(`${APIURLS.OUTBOX_CAPABILITY_URL}`, {userAddress: address});
    console.log("Outbox")
    console.log(outboxValues.data)
    setOutboxCapabilities(outboxValues.data.data)
  }

  useEffect(() => {
    fetchAccountData()
    fetchCapabilities()
    fetchInboxCapabilities()
    fetchOutboxCapabilities()
  }, [])



  return (
    <>
      <CapabilitiesManagerHeader accountData={accountData} capabilities={capabilities} totalInboxCapabilites={inboxCapabilities?.length} totalOutboxCapabilities={outboxCapabilities?.length}/>
      {/* Page content */}
      <Container className="mt--7" fluid>
        {/* Table */}
        <Row>
          <div className="col">
            <Card className="shadow" >
              <CardHeader className="border-0">
                <h3 className="mb-0">Public Capabilites</h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Path</th>
                    <th scope="col">Capability Name</th>
                    <th scope="col">Capability Kind</th>
                    <th scope="col">Capability Info</th>
                    <th scope="col">Action</th>
                    
                  </tr>
                </thead>
                <tbody>
                {capabilities && capabilities.publicCapabilities.map((capability) =>{
                      return(
                        <>
                        <tr>
                    <th scope="row">
                      <Media className="align-items-center">
                      
                        <Media>
                          <span className="mb-0 text-sm">
                          {capability.path}
                          </span>
                        </Media>
                      </Media>
                    </th>
                    <td> 
                       <span className="mb-0 text-sm">
                                   {capability.pathObject.identifier}
                        </span>
                    </td>
                    <td>
                    {capability?.type?.type?.kind}
                    </td>


                    <td>
                    <JsonView data={capability?.type} shouldInitiallyExpand={(level) => false} style={darkStyles} />
                    </td>
                    

                    <td className="text-left">
                      <UncontrolledDropdown>
                        <DropdownToggle
                          className="btn-icon-only text-light"
                          href="#pablo"
                          role="button"
                          size="sm"
                          color=""
                          onClick={(e) => {
                            e.preventDefault()
                          }}
                        >
                        <i className="fas fa-ellipsis-v" />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-arrow" right>
                          <DropdownItem
                            href="#pablo"
                            onClick={(e) => {
                              e.preventDefault()
                              setSendCapabilityData({name: capability.pathObject.identifier, pathObj: capability.pathObject})
                              sendCapabilityModalToggle()
                            }}
                          >
                            Send Capability
                          </DropdownItem>
                          
                          
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                        </>
                      )
                    })}

                  
                  
                </tbody>
              </Table>
             </Card>
          </div>
        </Row>
        {/* Dark table */}
        <Row className="mt-5">
          <div className="col">
            <Card className="bg-default shadow">
              <CardHeader className="bg-transparent border-0">
                <h3 className="text-white mb-0">Private Capabilites</h3>
              </CardHeader>
              <Table
                className="align-items-center table-dark table-flush"
                responsive
              >
                <thead className="thead-dark">
                <tr>
                    <th scope="col">Path</th>
                    <th scope="col">Capability Name</th>
                    <th scope="col">Capability Kind</th>
                    <th scope="col">Capability Info</th>
                    <th scope="col">Action</th>
                  </tr>
                </thead>
                <tbody>
                {capabilities && capabilities?.privateCapabilities?.map((capability) =>{
                      return(
                        <>
                        <tr>
                    <th scope="row">
                  
                          <span className="mb-0 text-sm">
                          {capability.path}
                          </span>
             
                    </th>
                    <td> 
                       <span className="mb-0 text-sm">
                                   {capability.pathObject.identifier}
                        </span>
                    </td>
                    <td>
                    {capability?.type?.type?.kind}
                    </td>

                    <td>
                    <JsonView data={capability?.type || {}} shouldInitiallyExpand={(level) => false} style={darkStyles} />
                    </td>
                  
                    <td className="text-left">
                      <UncontrolledDropdown>
                        <DropdownToggle
                          className="btn-icon-only text-light"
                          href="#pablo"
                          role="button"
                          size="sm"
                          color=""
                          onClick={(e) => e.preventDefault()}
                        >
                        <i className="fas fa-ellipsis-v" />
                        </DropdownToggle>
                        <DropdownMenu className="dropdown-menu-arrow" right>
                          <DropdownItem
                            href="#pablo"
                            onClick={(e) => {
                              e.preventDefault()
                              
                            }}
                          >
                            Send Capability
                          </DropdownItem>
                          
                          
                        </DropdownMenu>
                      </UncontrolledDropdown>
                    </td>
                  </tr>
                        </>
                      )
                    })}

                  
                  
                </tbody>
              </Table>
            </Card>
          </div>
        </Row>




        <Row>
          <div className="col mt-5">
            <Card className="shadow" >
              <CardHeader className="border-0">
                <h3 className="mb-0">Capability Inbox</h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Capability Name</th>
                    <th scope="col">Sender</th>
                    <th scope="col">Capability Kind</th>
                    <th scope="col">Capability Info</th>
                    <th scope="col">Action</th>
                    
                  </tr>
                </thead>
                <tbody>
                {inboxCapabilities && inboxCapabilities.map((capability) =>{
                      return(
                        <>
                        <tr>
                    <th scope="row">
                      <Media className="align-items-center">
                      
                        <Media>
                          <span className="mb-0 text-sm">
                          {capability.name}
                          </span>
                        </Media>
                      </Media>
                    </th>
                    <td>{capability.provider}</td>
                    <td>
                    {capability?.type?.type?.kind}
                    </td>

                    <td>
                    <JsonView data={capability?.type || {}} shouldInitiallyExpand={(level) => false} style={darkStyles} />

                    </td>

                    <td>
                    {capability?.status === "CLAIMED" ? "CLAIMED": (
                      <Button className="btn btn-success" style={{"margin-left":"20px", width: "200px"}} onClick={()=>{unsendCapability(capability.type, capability.name)}}>Claim</Button>
                    )}
                    </td>
                  
                  </tr>
                        </>
                      )
                    })}

                  
                  
                </tbody>
              </Table>
             </Card>
          </div>
        </Row>

        <Row>
          <div className="col mt-5">
            <Card className="shadow" >
              <CardHeader className="border-0">
                <h3 className="mb-0">Capability OutBox</h3>
              </CardHeader>
              <Table className="align-items-center table-flush" responsive>
                <thead className="thead-light">
                  <tr>
                    <th scope="col">Capability Name</th>
                    <th scope="col">Recipient</th>
                    <th scope="col">Capability Kind</th>
                    <th scope="col">Capability Info</th>
                    <th scope="col">Action</th>
                    
                  </tr>
                </thead>
                <tbody>
                {outboxCapabilities && outboxCapabilities.map((capability) =>{
                      return(
                        <>
                        <tr>
                    <th scope="row">
                      <Media className="align-items-center">
                      
                        <Media>
                          <span className="mb-0 text-sm">
                          {capability.name}
                          </span>
                        </Media>
                      </Media>
                    </th>
                    <td>{capability.provider}</td>
                    <td>
                    {capability?.type?.type?.kind}
                    </td>

                    <td>
                    <JsonView data={capability?.type || {}} shouldInitiallyExpand={(level) => false} style={darkStyles} />

                    </td>

                    <td>
                    {capability?.status === "CLAIMED" ? "CLAIMED": (
                      <Button className="btn btn-danger" style={{"margin-left":"20px", width: "200px"}} onClick={()=>{unsendCapability(capability.type, capability.name)}}>UnPublish</Button>
                    )}
                    </td>
                  
                  </tr>
                        </>
                      )
                    })}
                  
                </tbody>
              </Table>
             </Card>
          </div>
        </Row>
      </Container>
      <SendCapabilityModal modal={sendCapabilityModal} toggle={sendCapabilityModalToggle} capability={sendCapabilityData}  />
    </>
  );
};

export default CapabilitiesManager;
